import React from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { WindowHeader } from '@ff-os/shared-react/components/window/partials/WindowHeader';
import { GiftPdpState } from '@ff-scene-plugins/gift-redux/store';
import { PrefabHeading } from '@ff-scene-plugins/gift-shared/GiftSceneOptions';
import { selectPrefabHeading } from '../../../_redux-scene';

const _PrefabsWindowHeader = ({ heading, previous, onClose }: Props) => {

    const { t } = useTranslation();
    const translations: { [Key in PrefabHeading]: string } = {
        'layouts': t('windows.prefabs.heading.layouts'),
        'designs': t('windows.prefabs.heading.designs')
    };

    return (
        <WindowHeader previous={previous ?? onClose} onClose={onClose}>
            {t(translations[heading])}
        </WindowHeader>
    );
};

type Props = {
    heading: PrefabHeading;
    previous?: () => void;
    onClose: () => void;
};

const mapStateToProps = (state: GiftPdpState) => ({
    heading: selectPrefabHeading(state)
});

export const PrefabsWindowHeader = connect(
    mapStateToProps
)(_PrefabsWindowHeader);